import { Component, OnInit } from '@angular/core';
import { GeneralService } from 'src/app/services/general.service';

@Component({
  selector: 'app-rapport-visite-consult',
  templateUrl: './rapport-visite-consult.component.html',
  styleUrls: ['./rapport-visite-consult.component.scss'],
})
export class RapportVisiteConsultComponent implements OnInit {
  constructor(public generalService: GeneralService) {}
  rep;
  client;
  dateMin;
  dateMax;
  listRaport;
  selectedRapport;
  raportDetails;
  ngOnInit(): void {}

  search() {
    var formMinDate, formMaxDate;
    if (this.dateMin)
      formMinDate = this.generalService.convertDatefromat(this.dateMin);
    if (this.dateMax)
      formMaxDate = this.generalService.convertDatefromat(this.dateMax);
    this.generalService
      .rechercheTable2(
        'API_RapportVisite',
        (this.rep ? this.rep : '') +
          ',' +
          (this.client ? this.client : '') +
          ',' +
          (formMinDate ? formMinDate : '') +
          ',' +
          (formMaxDate ? formMaxDate : '')
      )
      .subscribe((res) => {
        this.listRaport = res;
        this.client = null;
        this.rep = null;
        this.selectedRapport = null;
      });
  }
  selectRapport(rapport) {
    this.generalService
      .rechercheTable2('API_RapportVisiteD', rapport.CRMActivity_Id)
      .subscribe((res) => {
        this.raportDetails = res[0];
      });
  }
}
